import { render, staticRenderFns } from "./AlternativeForm.vue?vue&type=template&id=1a806eb4"
import script from "./AlternativeForm.vue?vue&type=script&lang=js"
export * from "./AlternativeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports